module.exports = "<p class=\"form-text\">{{text}}</p>";